import supportModule from '../supportModule';
import { Cookies } from 'Roblox';
// Hacky way to determine dark mode as we do not respect $window.matchMedia('(prefers-color-scheme: dark)' as we should
// Other components (like captcha) use a query parameter but since the support form is a SPA, we cannot rely on that
const darkModeDetectFromColorString = 'rgb(57, 59, 61)';

const darkModeColors = {
  background: '#393b3d',
  text: '#ffffff',
  border: '#444444',
  titleBar: '#222222',
  titleBarText: '#ffffff',
  assistantBubble: '#555555',
  assistantBubbleText: '#ffffff',
  userBubble: '#dddddd',
  userBubbleText: '#000000'
};

const lightModeColors = {
  background: '#ffffff',
  text: '#000000',
  border: '#e0e0e0',
  titleBar: '#f0f0f0',
  titleBarText: '#000000',
  assistantBubble: '#f0f0f0',
  assistantBubbleText: '#000000',
  userBubble: '#000000',
  userBubbleText: '#ffffff'
};

const inactivityTimeoutSeconds = 300;

function chatLaunchController(
  $log,
  $q,
  $window,
  $document,
  $scope,
  supportService,
  modalService,
  languageResource,
  regexService,
  captchaV2Constants
) {
  'ngInject';

  function getNormalizedSierraVars() {
    const sierraStartContextVars = {
      ...$scope.supportFormPartialScope.accountContent,
      ...$scope.supportFormPartialScope.supportTicket
    };

    const subCategoryNameSelected = sierraStartContextVars.subCategory;
    const subCategoryDescription = sierraStartContextVars.mainCategory.subCategories.find(function (
      s
    ) {
      return s.name === subCategoryNameSelected;
    }).name;

    return {
      CATEGORY: sierraStartContextVars.mainCategory.mainCategory.name,
      SUBCATEGORY: subCategoryDescription,
      USERNAME: sierraStartContextVars.username,
      FIRST_NAME: sierraStartContextVars.name,
      CONTACT_EMAIL: sierraStartContextVars.email,
      DEVICE: sierraStartContextVars.deviceType,
      BYPASS_USER_SESSION_CHECK: $scope.isProd ? 'False' : 'True',
      ENVIRONMENT: !$scope.isProd ? 'staging' : 'production',
      BTID: Cookies?.getBrowserTrackerId() || ''
    };
  }

  // Hacky way to determine dark mode as we do not respect $window.matchMedia('(prefers-color-scheme: dark)' as we should
  // Other components (like captcha) use a query parameter but since the support form is a SPA, we cannot rely on that
  function isDarkMode() {
    const parentBackgroundColor = $window.getComputedStyle(
      document.querySelector('.support-section-content')
    ).backgroundColor;
    return parentBackgroundColor === darkModeDetectFromColorString;
  }

  function onLoad() {
    $scope.isChatLoading = false;
    try {
      $window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      $document.body.scrollTop = 0; // For Safari
      $document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE, and Opera
    } catch (e) {
      if (!$scope.isProd) console.error('Error auto-scrolling to top of page', e);
    }
  }

  function onTransfer(transfer) {
    if (!$scope.isProd) console.info(transfer);
  }

  function onClose() {
    $scope.isChatComplete = true;
    try {
      sierra.cleanup();
    } catch (e) {
      console.error('Error closing chat modal', e);
    }
  }

  function getAndConfigSierraChatAfterLoad() {
    const sierraConfig = {
      allowInternalFeedback: !$scope.isProd,
      persistence: 'none',
      variables: getNormalizedSierraVars(),
      initialUserMessage: $scope.supportFormPartialScope.supportTicket.message,
      customHideTitleBar: true,
      colors: isDarkMode() ? darkModeColors : lightModeColors,
      display: 'custom',
      customContainer: document.getElementById('chatWrapper'),
      inactivityTimeoutSeconds,
      showUserSurveyOnConversationEnd: true,
      onLoad,
      onTransfer,
      onClose
    };
    $window.sierraConfig = sierraConfig;
    return sierraConfig;
  }

  function onEligibleToLoadSierraSDKHandler(event, supportFormPartialScope) {
    $scope.isChatLoading = true;
    $scope.supportFormPartialScope = supportFormPartialScope;
    $scope.isEligibleForChat = true;
    sierra.init(getAndConfigSierraChatAfterLoad());
    sierra.openChatModal();
  }

  function configSierraChatBeforeLoad() {
    const sierraConfig = {
      waitForInit: true
    };
    $window.sierraConfig = sierraConfig;
  }

  $scope.$on('onEligibleToLoadSierraSDK', onEligibleToLoadSierraSDKHandler);

  $scope.sierraChatLoaded = function sierraChatLoaded() {
    if (!$scope.isProd) console.log('Sierra SDK loaded uninitialized.');
  };

  $scope.init = function init() {
    $scope.isProd = !String($window.location.origin).includes('sitetest'); // STx = staging, no mock, prod --> prod
    $scope.isChatLoading = false;
    $scope.isChatComplete = false;
    $scope.isEligibleForChat = false;
    $scope.supportFormPartialScope = {
      accountContent: { subCategory: '' },
      supportTicket: { mainCategory: { mainCategory: { name: '' }, subCategories: [{ name: '' }] } }
    };
    configSierraChatBeforeLoad();
  };

  $scope.init();
}

supportModule.controller('chatLaunchController', chatLaunchController);

export default chatLaunchController;
